export default "__VITE_ASSET__BpvzCB60__"